/**
 * Simple utility functions for API calls with restaurant ID
 */

/**
 * Add restaurant ID to request body for POST/PUT requests
 * @param {Object} data - Request data
 * @param {number} restaurantId - Restaurant ID to include
 * @returns {Object} Data with restaurant ID added
 */
export const addRestaurantIdToData = (data, restaurantId) => {
  if (!restaurantId) return data;
  return {
    ...data,
    restaurantId
  };
};

/**
 * Add restaurant ID to URL as query parameter for GET requests
 * @param {string} url - Base URL
 * @param {number} restaurantId - Restaurant ID to include
 * @returns {string} URL with restaurant ID parameter
 */
export const addRestaurantIdToUrl = (url, restaurantId) => {
  if (!restaurantId) return url;
  
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}restaurantId=${restaurantId}`;
};

/**
 * Simple fetch wrapper that adds restaurant ID to requests
 * @param {string} url - API endpoint URL
 * @param {Object} options - Fetch options
 * @param {number} restaurantId - Restaurant ID to include
 * @returns {Promise<Response>} Fetch response
 */
export const fetchWithRestaurant = async (url, options = {}, restaurantId = null) => {
  let finalUrl = url;
  let finalOptions = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    credentials: 'include',
  };

  // Add restaurant ID based on request method
  if (restaurantId) {
    if (options.method === 'GET' || !options.method) {
      // Add to URL for GET requests
      finalUrl = addRestaurantIdToUrl(url, restaurantId);
    } else if (options.body) {
      // Add to body for POST/PUT requests
      const bodyData = JSON.parse(options.body);
      finalOptions.body = JSON.stringify(addRestaurantIdToData(bodyData, restaurantId));
    }
  }
   
  return fetch(finalUrl, finalOptions);
};
